import { SET_INFOMATION_STORE_DETAIL_ACTION } from "../actions/InfomationStorePageAction/actionTypes";

const initialState = {
	infomationStore: {}
};

const infomationStorePageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_INFOMATION_STORE_DETAIL_ACTION: {
			return {
				...state,
				infomationStore: action.params.shop
			};
		}
		default:
			return state;
	}
};

export default infomationStorePageReducer;
